import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, ModalButtons } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ToggleModalSkeleton from '../../Skeletons/ToggleModalSkeleton';
import { DeleteModalState } from './DeleteModal';

type ModalProps = PropsWithChildren<{
  loading: boolean;
  approveModal: DeleteModalState;
  onCloseModal?: () => void;
  handleApprove?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const ApproveModal: FC<ModalProps> = props => {
  return (
    <Modal show={props.approveModal.status}>
      <ModalHeading heading={`Approve ${props.approveModal.data?.name}`} />
      {props.loading ? (
        <ToggleModalSkeleton />
      ) : (
        props.approveModal.data && (
          <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleApprove}>
            <InputsSection style={{ width: '34rem' }}>
              <p className='primaryText'>
                You are about to approve {props.approveModal.data.name}'s account.
                <br />
                <br /> 
                <span className='primaryText'>Are you sure you want to proceed?</span>
              </p>
            </InputsSection>
            
            <ModalButtons
              submitButtonLabel='Approve User'
              cancelButtonLabel='Cancel'
              onCancel={props.onCloseModal}
            />
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default ApproveModal;